import { Pipe, PipeTransform } from '@angular/core';
import { ITablaBody, ITablaBodyRow } from 'src/app/interfaces/calificaciones';

@Pipe({
  name: 'filtroAlumnos'
})
export class FiltroAlumnosPipe implements PipeTransform {
  transform(value: any, ...args: any[]): any {
    const inputText = args[0]
    const dataAlumnos = value
    let dataFiltrada: any = []

    dataAlumnos?.forEach((tabla: ITablaBody) => {
      const filtroAlumnos = tabla.row.filter((alumno: ITablaBodyRow, index: number) => {
        if ( alumno?.valor?.toUpperCase().includes(inputText.toUpperCase()) && (index === 1 || index === 2) ) {
          return true
        } else {
          return false
        }
      })
      if ( filtroAlumnos.length > 0 ) {
        dataFiltrada.push(tabla)
      }
    })
    return inputText === '' ? dataAlumnos : dataFiltrada
  }

}
